import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'HomeView', component: () => import('../views/HomeView.vue'), meta: { shell: 'modern', nav: 'home' } },
  { path: '/catalog', name: 'CatalogView', component: () => import('../views/CatalogView.vue'), meta: { shell: 'modern', nav: 'catalog' } },
  { path: '/library', name: 'LibraryView', component: () => import('../views/LibraryView.vue'), meta: { shell: 'modern', nav: 'library' } },
  { path: '/anime', name: 'AnimeView', component: () => import('../views/AnimeView.vue'), meta: { shell: 'modern', nav: 'home', desktopNav: 'anime' } },
  { path: '/media/:kind/:source/:id', name: 'MediaView', component: () => import('../views/MediaView.vue'), meta: { shell: 'modern', nav: 'home' } },
  { path: '/watch', name: 'PlayerView', component: () => import('../views/PlayerView.vue') },
  { path: '/watch/:kind/:source/:id', name: 'MediaPlayerView', component: () => import('../views/MediaPlayerView.vue') },
  { path: '/search', name: 'SearchView', component: () => import('../views/SearchView.vue'), meta: { shell: 'modern', nav: 'search' } },
  { path: '/classic', name: 'ClassicHomeView', component: () => import('../views/ClassicHomeView.vue') },
  { path: '/classicwatch', name: 'ClassicWatchView', component: () => import('../views/ClassicWatchView.vue') },
  { path: '/copyright', name: 'CopyrightHoldersView', component: () => import('../views/CopyrightHoldersView.vue'), meta: { shell: 'modern' } },
  { path: '/agreement', name: 'TermsOfUseView', component: () => import('../views/TermsOfUseView.vue'), meta: { shell: 'modern' } },
  { path: '/privacy', name: 'PrivacyPolicyView', component: () => import('../views/PrivacyPolicyView.vue'), meta: { shell: 'modern' } },
  { path: '/support', name: 'SupportUsView', component: () => import('../views/SupportUsView.vue'), meta: { shell: 'modern' } },
  { path: '/folder', name: 'FolderView', component: () => import('../views/FolderView.vue'), meta: { shell: 'modern', nav: 'catalog' } },
  { path: '/schedule', name: 'ScheduleView', component: () => import('../views/ScheduleView.vue'), meta: { shell: 'modern', nav: 'schedule' } },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
